import '../css/app.css'
import '../css/fonts.css'
import '../css/markdown.css'
import './bootstrap'

import { createInertiaApp, Head, Link } from '@inertiajs/vue3'
import * as Sentry from '@sentry/vue'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createApp, h } from 'vue'

const appName = 'J&M Sádrokartony'

createInertiaApp({
    title: (title) => (title ? `${title}` + ' | ' + appName : appName),
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })

        if (import.meta.env.VITE_SENTRY_DSN) {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                environment: import.meta.env.VITE_APP_ENV,
                // Errors only: any tracesSampleRate (even 0) turns tracing on.
                // Form values are personal data, keep them out of the reports.
                attachProps: false,
                // Dropped mobile connections and aborted prefetches are not bugs;
                // scripts injected by in-app browsers (Facebook) fail on their own.
                ignoreErrors: ['Network Error', 'Request aborted'],
                denyUrls: [/^iabjs:\/\//],
            })
        }

        return app.use(plugin).component('Head', Head).component('Link', Link).mount(el)
    },
    progress: {
        color: '#4B5563',
    },
})
